<template>
  <div class="content">
    <!-- <div class="header">
      <div
        v-for="(item,index) in labledata"
        :key="index"
        :class="{heightlight : lableindex==index}"
        @click="lableArea(index,item)"
      >
        {{item}}
        <div v-if="lableindex==index" class="xian"></div>
      </div>
    </div>-->
    <!-- <div class="metter" style="width:100%"> -->
    <!-- <div> -->
    <div class="table1" v-if="certifiData.length!==0" style="width:100%">
      <el-table
        :data="certifiData"
        :header-cell-style="{background:'#409EFF',color:'#fff',width:'100%'}"
        style="width:100%"
      >
        <el-table-column prop="code" label="证书编号" align="center" min-width="120" show-overflow-tooltip></el-table-column>

        <el-table-column prop="name" label="活动名称" align="center" min-width="100" show-overflow-tooltip></el-table-column>

        <el-table-column prop="unit" align="center" min-width="100" label="单位名称" show-overflow-tooltip></el-table-column>

        <el-table-column prop="publishtime" align="center" min-width="100" label="发证时间"></el-table-column>

        <el-table-column align="center" min-width="80" label="操作">
          <template slot-scope="scope">
            <el-button type="text" size="mini" @click="gotocerperson(scope.row)">查看详情</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div v-else style="margin-top:20px">
      <nodata></nodata>
    </div>
    <!-- </div> -->
    <!-- </div> -->
    <div class="pagination">
      <el-pagination
        background
        prev-text="上一页"
        next-text="下一页"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="listQuerys.page"
        :page-size="listQuerys.limit"
        layout=" total,prev, pager, next,jumper"
        :total="count"
        v-if="count>0"
      ></el-pagination>
    </div>
  </div>
</template>
<script>
import * as educat from '@/api/personcenter/index.js';
export default {
  data() {
    return {
      labledata: ['全部'],
      currentPage2: 1,
      lableindex: 0,
      listQuerys: {
        page: 1,
        limit: 10,
        userId: this.$store.state.User.ids,
      },
      count: 0,
      certifiData: '',
    };
  },
  created() {
    this.getList();
  },
  methods: {
    lableArea(index, item) {
      this.lableindex = index;
    },
    handleSizeChange(val) {
      // console.log(`每页 ${val} 条`);
      this.listQuerys.limit = val;
    },
    handleCurrentChange(val) {
      // console.log(`当前页: ${val}`);
      this.listQuerys.page = val;
      this.getList();
    },
    getList() {
      educat.CenterMyCerInfoList(this.listQuerys).then((res) => {
        this.certifiData = res.data;
        this.count = res.count;
      });
    },
    gotocerperson(item) {
      this.$router.push({
        path: '/certificate/peoplecerticate',
        query: {
          code: item.code,
        },
      });
    },
  },
};
</script>
<style scoped>
.content {
  /* width: 900px; */
  width: 100%;
  /* height: 1000px; */
  padding-bottom: 20px;
}
hr {
  margin: 1px;
  border-top: 1px solid #e2e3e6;
}
.heightlight {
  color: #409eff !important;
}
.header {
  /* width: 850px; */
  height: 40px;
  border-bottom: solid 1px #ccc;
  padding-top: 10px;
  display: flex;
  justify-content: space-between;
}
.header > div:nth-child(1) {
  width: 100px;
  text-align: center;
  line-height: 40px;
  font-size: 16px;
  cursor: pointer;
}
.teacherbook {
  position: relative;
  right: 20px;
  margin-right: 10px;
}
.header > div:nth-child(1):hover {
  color: #409eff;
}
.xian {
  width: 90px;
  border: solid 1px #409eff;
  margin-left: 8px;
}
.metter {
  padding: 20px;
  display: flex;
  flex-wrap: wrap;
}
.metter > div {
  /* padding-left: 18px; */
  margin-top: 10px;
  text-align: center;
  margin: 0 auto;
}

.nav {
  /* width: 830px; */
  height: 160px;
  /* background-color: blue; */
  margin-top: 16px;
  border-radius: 10px;
  border-style: solid;
  border-color: rgba(255, 255, 255, 1);
  box-shadow: 2px 2px 5px rgba(215, 215, 215, 0.968627450980392);
  /* padding-left: 16px; */
  padding-top: 12px;
  margin-left: 20px;
}
.nav:hover {
  box-shadow: 2px 2px 5px rgba(52, 194, 250, 0.969) !important;
}
.pagination {
  margin-top: 20px;
  text-align: center;
}
.tablehead {
  display: flex;
  height: 46px;
  color: #fff;
  background: #409eff;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
}
.table_container {
  display: flex;
  height: 40px;
  border-bottom: 1px solid #efefef;
}

.el-table__header {
  width: 100%;
}
</style>